<template>
  <div class="schedule-event">
    <div class="schedule-event-content">
       <div class="event-header flex">
          <span>Schedule event for {{driverName || info.driverName || '--'}}</span>
          <svg-icon style="color: #7f8596; width: 24px;height: 24px; cursor: pointer;" name="close" @click.native="close"></svg-icon>
        </div>
        <el-form class="event-form" :model="form" ref="ruleForm">
          <div>
            <el-form-item label="">
              <city 
                v-model="form.location"
                labelKey='End Location'
                @clear='clearCity'
                @cityClear="clearCity"
                :currentValue="form.location"
                @getLoaction='getLoaction'></city>
            </el-form-item>
          </div>
          <div class="schedule-event-date">
            <div>
              <el-form-item  
                prop="startDate"
                :rules="formRules.validatorRequired('Start date is required.')">
                <common-input-date
                  :clearable="false"
                  label="Start Date"
                  :picker-options="startOption"
                  v-model="form.startDate"
                  @change="form.startTime = ''"
                ></common-input-date>
              </el-form-item>
            </div> 
            <div>
              <el-form-item prop="startTime" :rules="formRules.validatorRequired('Start time is required.')">
                <commonTimeSelect
                  v-model="form.startTime"
                   :picker-options="{
                      start: '00:00',
                      step: '00:30',
                      end: '23:30',
                    }"
                  label="Start Time"
                  class="city-time"
                  @change="changeStartTime"
                ></commonTimeSelect>
              </el-form-item>
            </div>
          </div>
          <div class="schedule-event-date">
            <div>
              <el-form-item prop="endDate" :rules="formRules.validatorRequired('End date is required.')">
                <common-input-date
                  :clearable="false"
                  label="End Date"
                  v-model="form.endDate"
                  :picker-options="pickOption"
                   @change="form.endTime = ''"
                ></common-input-date>
              </el-form-item>
            </div> 
            <div>
              <el-form-item prop="endTime" :rules="formRules.validatorRequired('End time is required.')">
                <commonTimeSelect
                  v-model="form.endTime"
                   :picker-options="{
                      start: '00:00',
                      step: '00:30',
                      end: '23:30',
                      minTime: handleIsMin(form.startDate, form.endDate, form.startTime)
                    }"
                  value-format="timestamp"
                  label="End Time"
                    @change="changeEndTime"
                  class="city-time"
                ></commonTimeSelect>
              </el-form-item>
            </div>
          </div>
          <div class="schedule-descript">
            <el-form-item label="">
              <!-- <common-input
              label="Description"
              resize="none"
              maxlength="520"
              v-model="form.note"
              type="textarea"></common-input>  -->              
              <elTextArea  resize="none" labelKeys='Description' v-model="form.note" textareaPlaceholder="Description"></elTextArea>
            </el-form-item>
          </div>
          <!-- </el-form-item> -->
        </el-form>
        <div class="event-footer">
          <div class="event-button">
            <span class="">Repeat every week</span>
            <el-switch 
            :width="32"
            :disabled="disabledSwitch"
            v-model="form.weekRepeat"></el-switch>
          </div>
          <div class="event-operator">
            <common-button size="small" type="info" @click="close">CANCEL</common-button>
            <common-button size="small" :loading="addLoading" type="primary" @click="save">SAVE</common-button>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import city from './city.vue'
import moment from 'moment'
import appendToDom from "@/components-v3/mixins/append-to-dom"
import { addScheduleEvent, editScheduleEvent } from '@/api/schedule'
import * as formRules from "@/utils/form-rules";
import {systemInfo} from "@/shared-services";
import elTextArea from '@/views/dispatchs/dispatch/form/_form-add-document/textarea-el-input.vue'
export default {
  mixins: [appendToDom()],
  name: 'scheduleEvent',
  components: {
    city,
    elTextArea
  },
  props: {
    driverInfo: {
      type: Object,
      default: function() {
        return {}
      }
    },
    showEvent: {
      type: Boolean
    },
    info: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      formRules,
      pickOption: {
        disabledDate:(time)=> {
          return time.getTime() < this.form.startDate
        }
      },
      startOption: {
        disabledDate:(time)=> {
          if (this.form.endDate) {
            return time.getTime() > this.form.endDate
          } else {
            return false
          }
        }
      },
      driverName: '',
      disabledSwitch: false,
      addLoading: false,
      form: {
        startDate: '',
        startTime: '',
        endDate: '',
        endTime: '',
        location: '',
        note: '',
        weekRepeat: false,
        showaddress: '',
        city: '',
        state: ''
      }
    }
  },
  watch: {
    form: {
      handler(val) {
        if (val.startDate && val.startTime && val.endDate && val.endTime) {
          if (this.getTime(this.form.startDate, this.form.startTime) + 7 * 24 * 60 * 60 * 1000 < this.getTime(this.form.endDate, this.form.endTime)) {
          this.disabledSwitch = true
          this.form.weekRepeat = false
          } else {
          this.disabledSwitch = false
          }
        }
      },
      deep: true,
      immediate: true
    },
    info: {
      handler(val) {
        console.log(val, 'adasdasda')
        if (val.type == 'edit') {
          if (val.eventFrom) {
            this.form.startDate = parseFloat(moment(moment(val.eventFrom).format('YYYY-MM-DD')).format('x'))
            this.form.startTime = moment(val.eventFrom).format('HH:mm')
          }
          if (val.eventTo) {
            this.form.endDate = parseFloat(moment(moment(val.eventTo).format('YYYY-MM-DD')).format('x'))
            this.form.endTime = moment(val.eventTo).format('HH:mm')
          }
          this.form = Object.assign({}, this.form, val)
          this.driverName = val.driverName
        }
        if (this.driverInfo.driverTeam) this.driverName = this.driverInfo.teamName
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    save() {
      this.$refs.ruleForm.validate(res => {
        if (res) {
           let params = {
            // driverId: this.driverInfo.driverId,
            eventFrom: this.getTime(this.form.startDate, this.form.startTime),
            eventTo: this.getTime(this.form.endDate, this.form.endTime),
            eventType: 'break',
            note: this.form.note,
            weekRepeat: this.form.weekRepeat,
            location: this.form.location,
            city: this.form.city,
            state: this.form.state,
            driverId: this.info.driverId
          }
          // if (this.driverInfo.driverTeam) {
          //   params.teamId = this.driverInfo.teamId
          // } else {
          //   params.driverId = this.driverInfo.driverId
          // }
          if (!systemInfo.isCommand) {
            params.fleetCompanyId = this.info.fleetCompanyId
          }
          this.addLoading = true
          if (this.info.type == 'edit') {
            params.id = this.info.id
            editScheduleEvent(params).then(res => {
              console.log(res)
              this.close()
              this.$emit('refush')
            })
          } else {
            addScheduleEvent(params).then(res => {
              console.log(res)
              this.close()
              this.$emit('refush')
            })
          }
        
        }
      })
    },
    handleIsMin(startTime, endTime, time) {
      if (startTime && endTime) {
        startTime = moment(startTime).format('YYYY-MM-DD')
        endTime = moment(endTime).format('YYYY-MM-DD')
        return startTime === endTime ? time : ''
      } else {
        return ''
      }
    },
    close(){
      this.$emit('close', false)
    },
    getLoaction(data) {
      let city = data.cityData
      this.form.state = city.state
      this.form.city = city.city
      console.log(city)
    },
    clearCity() {
      this.form.location = ``
       this.form.state = ''
      this.form.city = ''
      // this.form.showaddress = ''
    },
    getTime(date, time) {
      if (date && time) {
        date = parseFloat(date)
        return parseFloat(moment(moment(date).format('YYYY-MM-DD') + ' ' + time).format('x'))
      }
    },
    changeStartTime() {
      if (this.form.startDate 
          && this.form.endDate
          && moment(this.form.startDate).format('YYYY-MM-DD') === moment(this.form.endDate).format('YYYY-MM-DD')
          && this.form.endTime
          && this.form.startTime
          && this.getTime(this.form.startDate, this.form.startTime) > this.getTime(this.form.endDate, this.form.endTime)
          ) {
            this.form.endTime = ''
        }
    },
    changeEndTime() {
      if (this.form.startDate 
          && this.form.endDate
          && moment(this.form.startDate).format('YYYY-MM-DD') === moment(this.form.endDate).format('YYYY-MM-DD')
          && this.form.endTime
          && this.form.startTime
          && this.getTime(this.form.startDate, this.form.startTime) > this.getTime(this.form.endDate, this.form.endTime)
          ) {
            this.form.startTime = ''
        }
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-icon-time::before {
  display: block;
  height: 16px;
  width: 16px;
  content: url('~@/assets/img/schedule/icon-16-time.svg');
  transform: translateY(2px) translateX(4px);
}
.flex{
  display: flex;
}
  .schedule-event{
    position: fixed;
    z-index: 2001;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;

    &::before{
      position: fixed;
      content: '';
      bottom: 0;
      left: 0;
      right: 0;
      top: 0;
      z-index: 3000;
      background: rgba(0,0,0, 0.65);
    }
  }
  .schedule-event-content{
    position: fixed;
    z-index: 3002;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    width: 404px;
    height: 458px;
    border-radius: 4px;
  }
  .event-header{
    height: 72px;
    padding: 0 24px 0 24px;
    align-items: center;
    justify-content: space-between;
    // background: #4066d4;
    border-bottom: 1px solid  #dadce1;
    span{
      max-width: 85%;
      font-weight: bold;
      font-size: 18px;
      color: #222632;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .schedule-event-date{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 32px;
    height: 36px;
    // overflow: hidden;
    & > div{
      width: 166px;
    }

    &+.schedule-event-date{
      
    }
  }
  .event-form{
    padding: 24px;
    height: 305px;
    border-bottom: 1px solid #dadce1;
    /deep/ {
      .el-form-item{
        margin-bottom: 0;
        &::after{
          display: none;
        }
      }
      .el-form-item__content{
        line-height: auto;
        height: 36px;
      }
    }
  }
  .schedule-descript{
    height: 60px;
    margin-top: 24px;
    /deep/ .el-textarea__inner{
      height: 60px;
      
      border-color:#b4bac8;

      &:focus{
        border-color: #4066d4;
      }
    }
  }
  .event-footer{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 80px;
    padding: 0 24px;
  }
  .event-operator{}
  .event-button{
    span{
      font-family: OpenSans-Semibold;
      font-size: 12px;
      line-height: 20px;
      color: #000c2e;
      margin-right: 8px;
    }
    /deep/ {
      .el-switch__core{
        height: 16px;

        &::after{
          height: 12px;
          width: 12px;
          margin-left: 1px;
        }
      }
      .el-switch.is-checked .el-switch__core::after{
        margin-left: -14px;
      }
      .el-switch.is-checked .el-switch__core{
        background: #29a360;
        border-color: #29a360;
      }
    }
  }
</style>
